import { Button, Flag, Typography } from '@compass/components'
import { CircleMinus, CirclePlus } from 'lucide-react'

import { IdentificationUrlKeys } from '../../../types'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { useEventsTableActions } from './EventsTableActions'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.IpAddress
const label = 'IP address' // visitFilterLabelMap[key] // conforming the existing analytics label

export const ipAddressColumn = () =>
  columnHelper.display({
    id: 'ip',
    header: 'IP Address',
    cell: ({ row }) => {
      const ipAddress = row.original.ip_address
      const ipLocation = row.original.ip_info?.v4 || row.original.ip_info?.v6
      const geolocation = ipLocation?.geolocation

      if (!ipAddress || ipAddress === '0.0.0.0') {
        return <Unavailable />
      }

      return <IpAddressCell ipAddress={ipAddress} countryCode={geolocation?.country_code} />
    },
  })

function IpAddressCell({ ipAddress, countryCode }: { ipAddress: string; countryCode?: string }) {
  const { ipFilter } = useEventsTableActions()

  return (
    <CellAction
      copyValue={ipAddress}
      search={(old) => ({ ...old, [key]: ipAddress })}
      field={label}
      className='min-w-40'
      extraActions={
        ipFilter
          ? [
              <Button
                key='include'
                variant='secondary'
                size='sm'
                isIcon
                aria-label={`Include IP ${ipAddress}`}
                onPress={() => ipFilter.onInclude(ipAddress)}
              >
                <CirclePlus />
              </Button>,
              <Button
                key='exclude'
                variant='secondary'
                size='sm'
                isIcon
                aria-label={`Exclude IP ${ipAddress}`}
                onPress={() => ipFilter.onExclude(ipAddress)}
              >
                <CircleMinus />
              </Button>,
            ]
          : undefined
      }
    >
      <div className='flex flex-row gap-2 items-center'>
        {countryCode && <Flag countryCode={countryCode} />}
        <Typography className='font-mono'>{ipAddress}</Typography>
      </div>
    </CellAction>
  )
}
